import moment, { Moment } from 'moment';

// measurement of the div that contains the month name in `Month` component
const HEADER_HEIGHT = 21;
// `row-gap` value in the `Month` component stylesheet
const ROW_GAP = 6;
// `$day-size` variable value in `_variables.scss`
const ROW_HEIGHT = 36;

const weeksOfMonth = (month: Moment): number => {
  const startMonth = moment(month).startOf('month');
  const startWeek = moment(startMonth).startOf('isoWeek');
  const startOffset = startMonth.diff(startWeek, 'days');

  const endMonth = moment(month).endOf('month');
  const endWeek = moment(endMonth).endOf('isoWeek');
  const endOffset = endWeek.diff(endMonth, 'days');

  return Math.ceil((endMonth.diff(startMonth, 'days') + startOffset + endOffset) / 7);
};

export const getMonthHeight = (month: Moment): number => {
  const rowCount = weeksOfMonth(month);
  const totalRowHeight = ROW_HEIGHT * rowCount;
  // grid row gap between each row
  const totalRowGap = ROW_GAP * (rowCount - 1);
  return HEADER_HEIGHT + totalRowHeight + totalRowGap;
};
